
















































































































































import { IUser } from "@/@types/admin/user/user";
import { IBar } from "@/@types/menu/bars/bars";
import { Component, Prop, Vue } from "vue-property-decorator";

import InputSearch from "@/components/app/search/input-search.vue";

@Component({ components: { InputSearch } })
export default class HeaderOrderList extends Vue {
  @Prop({ type: Array, default: () => [] }) managers!: Array<IUser>;
  @Prop({ type: Array, default: () => [] }) routes!: Array<string>;
  @Prop({ type: Array, default: () => [] }) bars!: Array<IBar>;
  @Prop({ type: Object, default: null }) manager!: IUser;
  @Prop({ type: String, default: "" }) status!: string;
  @Prop({ type: String, default: "" }) route!: string;
  @Prop({ type: Object, default: null }) bar!: IBar;

  statuses = ["new", "active", "cancel", "closed", "freeze"];

  get statusVariant(): string {
    if (this.status == "new") return "success";
    if (this.status == "cancel") return "danger";
    if (this.status == "closed") return "secondary";
    return "light";
  }

  changeOrderStatus(status: string): void {
    this.$emit("changeStatus", status);
    localStorage.setItem("order_show_new", String(this.status));
  }
}
